export const PHOTOS = {
  wellness: '/images/ph-wellness.webp',
  woman: '/images/ph-woman.webp',
  womanWarm: '/images/ph-womanwarm.webp',
  man: '/images/ph-man.webp',
  manPortrait: '/images/ph-manportrait.webp',
  fitness: '/images/ph-fitness.webp',
  lab: '/images/ph-lab.webp',
  labTubes: '/images/ph-labtubes.webp',
  doctor: '/images/ph-doctor.webp',
  peptide: '/images/ph-peptide.webp',
  longevity: '/images/ph-longevity.webp',
  older: '/images/ph-older.webp',
  meds: '/images/ph-meds.webp',
  videocall: '/images/ph-videocall.webp',
  food: '/images/ph-food.webp',
  glp: '/images/ph-glp.webp',
  glp800: '/images/ph-glp-800.webp',
  heroWeightLoss: '/images/ph-heroweightloss.webp',
  tirzepatide: '/images/ph-tirzepatide.webp',
  heroWomens: '/images/ph-herowomens.webp',
  heroMens: '/images/ph-heromens.webp',
  heroPeptides: '/images/ph-heropeptides.webp',
  heroLongevity: '/images/ph-herolongevity.webp',
  vitalityWomen: '/images/ph-vitalitywomen.webp',
  recovery: '/images/ph-recovery.webp',
}

/**
 * Home hero photo — the page's LCP element. Phones get a portrait centre crop
 * (23 KB vs 65 KB): it's all a phone ever showed of the landscape original, and
 * at 26% opacity the lower quality doesn't show. Preloaded into the
 * prerendered home page by scripts/prerender.mjs.
 */
export const HERO_PHOTO = {
  src: PHOTOS.wellness,
  mobileSrc: '/images/ph-wellness-mobile.webp',
  mobileMedia: '(max-width: 640px)',
}

export const LOGOS = {
  primary: '/images/logo-primary.webp',
  primary360: '/images/logo-primary-360.webp',
  berry: '/images/logo-berry.webp',
  nameWhite: '/images/logo-namewhite.webp',
  vertWhite: '/images/logo-vertwhite.webp',
  monoBerry: '/images/logo-monoberry.webp',
  monoWhite: '/images/logo-monowhite.webp',
}

export const healberryLogo = LOGOS.primary
export const healberryMark = LOGOS.berry
export const healberryHeroLogo = LOGOS.vertWhite
